// extracted by mini-css-extract-plugin
export var details = "_fq-0";
export var inspectorPopover = "_fq-1";